import { Box } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

export const DividerHorizontal = styled(Box, {})({
  margin: '29px 0 20px',
  width: 'calc(100% + 60px)', // 2*30px padding on container
  height: 1,

  background: theme.palette.midgrey,

  transform: 'translateX(-30px)',
});
